import React, { Component } from "react";
import firebase from "../../firebase";
import swal from "sweetalert";

export default class StepFour extends Component {
  state = {
    showPassword: false,
    image: "",
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    password: "",
    verified: false,
    aboutMe: "",
    educationType: "",
    degree: ""
  };
  componentDidMount() {}
  auth = () => {
    if (
      this.state.mobileNumber === null ||
      this.state.mobileNumber === undefined ||
      this.state.mobileNumber === "" ||
      this.state.mobileNumber === " "
    ) {
      document.getElementById("mobile").focus();
      return false;
    }
    // var element = document.getElementById("otp");
    // element.classList.add("hide");
    var recaptcha = new firebase.auth.RecaptchaVerifier("recaptcha", {
      size: "invisible",
      callback: function(response) {
        // reCAPTCHA solved - will proceed with submit function
        console.log(response);
      },
      "expired-callback": function() {
        // Reset reCAPTCHA?
      }
    });
    var number = "+91" + document.getElementById("mobile").value;
    var firebaseRef = firebase.auth().signInWithPhoneNumber(number, recaptcha);
    firebaseRef
      .then(e => {
        swal("Enter OTP:", {
          content: "input"
        }).then(code => {
          if (code === null) return;
          e.confirm(code).then(result => {
            console.log(result);
            // console.log('Result:', result.user);
            // this.guestuser_registration();
            swal({
              title: "Verification Successful",
              text: "",
              icon: "success"
            });
            this.verified();
          });
          // .catch(function(error) {
          //   console.error("Error", error);
          //   swal({
          //     title: "Incorrect",
          //     text: "Enter Correct Mobile No",
          //     icon: "warning"
          //   }).then(function() {
          //     window.location.reload();
          //   });
          // });
        });
      })
      .catch(error => {
        console.error("Error", error);
        swal({ title: "Warning", text: error.message, icon: "warning" }).then(
          function() {
            // window.location.reload();
          }
        );
      });
  };
  onInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onRegister = e => {
    e.preventDefault();

    var password = document.getElementById("password");
    var mobileNumber = document.getElementById("mobileNumber");
    var passwordAlert = document.querySelector(".password-alert");
    var mobileNumberAlert = document.querySelector(".mobile-number-alert");

    if (password.value.length < 6) {
      passwordAlert.classList.remove("d-none");
      setTimeout(() => {
        passwordAlert.classList.add("d-none");
      }, 3000);
      return false;
    }
    if (mobileNumber.value.length < 10) {
      mobileNumberAlert.classList.remove("d-none");
      setTimeout(() => {
        mobileNumberAlert.classList.add("d-none");
      }, 3000);
      return false;
    }

    this.props.onRegister(this.state);
  };

  changePicture = () => {
    document.getElementById("input-image").click();
  };

  setImage = e => {
    var input = e.target;
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function(e) {
        var imageElement = document.querySelector(".image-cover");
        imageElement.src = e.target.result;
      };
      reader.readAsDataURL(input.files[0]);
    }
  };

  verified = () => {
    this.setState({ verified: true });
  };

  render() {
    return (
      <div className="step-item stepper container">
        <div className="my-3 text-center">
          <h4>Profile Details</h4>
          <p className="blockquote-footer">
            Choose your profile pic and tell us about you.
          </p>

          <form onSubmit={this.onRegister}>
            <div className="row">
              <div class="col-md-4">
                <div
                  className="p-0 banner-wrap"
                  id="banner-input-wrap"
                  onClick={this.changePicture}
                >
                  <img
                    src="https://unlimitedpassion.co.uk/wp-content/uploads/2016/06/placeholder4.png"
                    alt=""
                    style={{ width: "" }}
                    className="image-cover"
                  />
                </div>
                <input
                  type="file"
                  class="edit-mode"
                  id="input-image"
                  name="image"
                  accept="image/*"
                  capture
                  style={{ display: "none" }}
                  onChange={this.setImage}
                />
              </div>
              <div className="col-md-8">
                <div class="form-group m-0 row">
                  <div className="col-md-6 p-1">
                    <input
                      type="text"
                      class="form-control"
                      name="firstName"
                      placeholder="First name"
                      required="required"
                      onChange={this.onInputChange}
                      value={this.state.firstName}
                    />
                  </div>
                  <div className="col-md-6 p-1">
                    <input
                      type="text"
                      class="form-control"
                      name="lastName"
                      placeholder="Last name"
                      required="required"
                      onChange={this.onInputChange}
                      value={this.state.lastName}
                    />
                  </div>
                </div>
                <div class="form-group m-0 row">
                  <div className="col-md-12 p-1">
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      placeholder="Email address"
                      required="required"
                      onChange={this.onInputChange}
                      value={this.state.email}
                    />
                  </div>
                </div>
                <div class="form-group m-0 row">
                  <div className="col-md-12 p-1 input-group">
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      class="form-control"
                      name="password"
                      placeholder="Set Password"
                      id="password"
                      required="required"
                      onChange={this.onInputChange}
                      value={this.state.password}
                    />
                    <div class="input-group-append">
                      <div
                        class="input-group-text mobile-number"
                        onClick={() => {
                          this.setState({
                            showPassword: !this.state.showPassword
                          });
                        }}
                      >
                        {this.state.showPassword ? (
                          <i class="fa fa-eye-slash" />
                        ) : (
                          <i class="fa fa-eye" />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 m-1 alert p-1 alert-danger password-alert text-center login-error d-none">
                  Please enter Minimum 6 characters
                  </div>
                </div>
                <div class="form-group m-0 row">
                  <div className="col-md-9 p-1 input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text  mobile-number">+91</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="mobileNumber"
                      name="mobileNumber"
                      placeholder="Mobile No."
                      required="required"
                      onChange={this.onInputChange}
                      value={this.state.mobileNumber}
                    />
                  </div>
                  <div class="col-md-3 p-1 input-group">
                    {this.state.verified ? (
                      <button class="btn btn-sm btn-primary w-100">
                        Verified
                      </button>
                    ) : (
                      <button
                        class="btn btn-sm btn-primary w-100"
                        onClick={this.auth}
                      >
                        Verify
                      </button>
                    )}
                  </div>
                  <div id="recaptcha" />
                  <div className="col-md-12 m-1 alert p-1 alert-danger mobile-number-alert text-center login-error d-none">
                    Please enter valid mobile number
                  </div>
                 
                </div>
              </div>

              <div className="col-md-12 mt-3 mb-4">
                <div className="row">
                  <div className="col-md-12">
                    <label className="text-left">
                      My education qualification
                    </label>
                  </div>
                  <div className="col-md-6">
                    <select
                      class="form-control"
                      id="educationType"
                      name="educationType"
                      value={this.state.educationType}
                      onChange={this.onInputChange}
                      // onChange={this.selectSehedule}
                    >
                      <option>Bachelors</option>
                      <option>Masters</option>;
                    </select>
                  </div>
                  <div className="col-md-6">
                    <select
                      class="form-control"
                      id="degree"
                      name="degree"
                      value={this.state.degree}
                      onChange={this.onInputChange}
                      // onChange={this.selectSehedule}
                    >
                      <option>B.Sc</option>
                      <option>M.Sc</option>
                      <option>B.Com</option>
                      <option>M.Com</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <label className="text-left">About me</label>
                <textarea
                  type="text"
                  class="form-control"
                  name="aboutMe"
                  placeholder="Tell us about you.."
                  required="required"
                  onChange={this.onInputChange}
                  value={this.state.aboutMe}
                />
              </div>

              <div className="col">
                <input
                  class="btn btn-primary get-started-btn mt-5"
                  value="Register"
                  type="submit"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
